// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8868fcbb","513":"246eb5e4","703":"f9a0b603","787":"cc049840"}[chunkId] + ".chunk.js";
};